'use client';
export default function CoverPictureOwnerAttribute({ text }: { text: string | null }) {
  if (!text) return null;

  return (
    <span
      className="block w-full text-right text-xs"
      dangerouslySetInnerHTML={{
        __html: text
      }}
    />
  );
}
